import { render, staticRenderFns } from "./filter-item.vue?vue&type=template&id=c245a290&scoped=true&"
import script from "./filter-item.vue?vue&type=script&lang=js&"
export * from "./filter-item.vue?vue&type=script&lang=js&"
import style0 from "./filter-item.vue?vue&type=style&index=0&id=c245a290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c245a290",
  null
  
)

export default component.exports